var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.editProjectIcon,on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[_c('font-awesome-icon',{class:_vm.$style.icon,attrs:{"icon":"pen"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }